var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', [_c('h1', [_vm._v("e커머스피칭페스타 소개")]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', [_vm._v("소개페이지 데이터는 "), _c('b', [_vm._v("[관리자 > e커머스피칭페스타 소개]")]), _vm._v(" 페이지에 접속하시면 수정할 수 있습니다.")]), _c('div', [_c('b', [_vm._v("festa 오브젝트")]), _vm._v("에 담겨져 있고, 그 안에 "), _c('b', [_vm._v("section + 2~6")]), _vm._v(" 네이밍으로 데이터가 들어가 있습니다.")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('b', [_vm._v("채연씨 요청사항)")])]), _c('div', [_vm._v(" * 로고는 한줄에 최대 4개씩만 들어가며, 4개 미만일때 왼쪽 정렬해달라고 요청해주셨습니다.")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('b', [_vm._v("수정시 유의사항)")])]), _c('div', [_vm._v(" * "), _c('b', [_vm._v("v-html")]), _vm._v("은 삭제하지 말아주세요. 엔터가 html에서 보여지지 않기때문에, br태그로 변경해주어야 하기 때문입니다.")]), _c('div', {
    staticClass: "mt-4"
  }, [_c('b', [_vm._v("23.02.28 채연씨 추가 요청) 개최 성과 추가")])]), _c('div', [_vm._v(" * 개최 성과 텍스트가 추가되었습니다, "), _c('b', [_vm._v("festa.section4.txt[0]")]), _vm._v(" 데이터 바인딩이 추가되었습니다.")]), _c('example-layout', {
    staticClass: "overflow-auto mt-8",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function fn() {
        return [_c('example-festa')];
      },
      proxy: true
    }, {
      key: "editor",
      fn: function fn() {
        return [_c('prism-editor', {
          staticClass: "rounded",
          attrs: {
            "line-numbers": ""
          },
          model: {
            value: _vm.example.section_1.code,
            callback: function callback($$v) {
              _vm.$set(_vm.example.section_1, "code", $$v);
            },
            expression: "example.section_1.code"
          }
        })];
      },
      proxy: true
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }